let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5JTxv"), load("lnKog")]).then(() => parcelRequire('2mcHd'));